import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Bold = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M33.342 22c2.444-2.207 3.995-5.378 3.995-8.926 0-6.635-5.392-12.026-12.027-12.026H6.648v41.904h18.676c6.635 0 12.027-5.391 12.027-12.026 0-3.548-1.55-6.719-4.01-8.926ZM12.836 7.236h12.488a5.845 5.845 0 0 1 5.839 5.838 5.845 5.845 0 0 1-5.839 5.839H12.836V7.236Zm12.488 29.528H12.836V25.087h12.488a5.845 5.845 0 0 1 5.839 5.839 5.845 5.845 0 0 1-5.839 5.838Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 1.048C5.6.469 6.07 0 6.649 0H25.31c7.213 0 13.074 5.86 13.074 13.074 0 3.46-1.356 6.589-3.546 8.924 2.203 2.336 3.56 5.466 3.56 8.928 0 7.213-5.86 13.074-13.074 13.074H6.648a1.048 1.048 0 0 1-1.047-1.048V1.048Zm2.096 1.047v39.81h17.628c6.056 0 10.98-4.923 10.98-10.98 0-3.233-1.412-6.126-3.662-8.145a1.048 1.048 0 0 1-.002-1.558c2.238-2.02 3.65-4.914 3.65-8.148 0-6.056-4.924-10.979-10.98-10.979H7.696Zm4.093 5.14c0-.578.469-1.047 1.047-1.047h12.488c3.79 0 6.886 3.08 6.886 6.886 0 3.79-3.08 6.887-6.886 6.887H12.836a1.048 1.048 0 0 1-1.047-1.048V7.236Zm2.095 1.048v9.582h11.44a4.797 4.797 0 0 0 4.791-4.79 4.797 4.797 0 0 0-4.791-4.792h-11.44Zm-2.095 16.804c0-.579.469-1.048 1.047-1.048h12.488c3.79 0 6.886 3.08 6.886 6.887 0 3.807-3.096 6.886-6.886 6.886H12.836c-.578 0-1.047-.469-1.047-1.048V25.087Zm2.095 1.048v9.582h11.44a4.797 4.797 0 0 0 4.791-4.791 4.797 4.797 0 0 0-4.791-4.791h-11.44Z"
  }));
});
Bold.displayName = 'Bold';
Bold.defaultProps = {
  'aria-label': 'Bold'
};
export default Bold;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Bold.js
// module id = 2906
// module chunks = 11